export const getInitialComment = (rawCommentValue) => {
  if (!rawCommentValue) {
    return '';
  }
  return `<br/>${rawCommentValue}`;
};

export default getInitialComment;
